import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

export const useDeleteDefensive = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            try {
                return (await api.delete(`/agricultural-defensives/delete/${id}`)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar defensivo');
            }
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['defensives'] }),
        onError: (error) => {
            console.error('Erro ao deletar defensivo:', getApiErrorMessage(error, 'Erro ao deletar defensivo'))
        },
    });
};
